import MobileDetect from 'mobile-detect'
import { mapGetters } from 'vuex'

export default {
  props: ['slug', 'record', 'type', 'id'],
  methods: {
    autoScrollMobile () {
      const elem = document.querySelector('.ps')
      var chatHeight = document.querySelector('.chat-scroll').offsetHeight
      elem.scrollTop = chatHeight + 200
    },
    autoScrollDesktop () {
      const elem = document.querySelector('.ps')
      var chatArea = document.querySelector('.chat-scroll')
      elem.scrollTop = chatArea.scrollHeight
    },
    startAnimation () {
      let target = this.$refs.formWrapper
      if (this.animeComponent) {
        this.anime({
          targets: target,
          easing: 'easeInOutQuad',
          translateY: [
            { value: 400, duration: 200 },
            { value: 0, duration: 800 }
          ],
          opacity: [
            { value: 0, duration: 100 },
            { value: 1, duration: 400 }
          ]
        })
      } else {
        this.anime({
          targets: target,
          translateX: 0,
          opacity: [
            { value: 0, duration: 100 },
            { value: 1, duration: 350 }
          ]
        })
      }
    },
    async endAnimation (callback) {
      let target = this.$refs.formWrapper
      await this.anime({
        targets: target,
        easing: 'easeInOutQuad',
        translateY: [
          { value: 0, duration: 100 },
          { value: 0, duration: 300 },
          { value: 400, duration: 1000 }
        ],
        opacity: [
          { value: 1, duration: 800 },
          { value: 0, duration: 400 }
        ]
      }).finished

      await callback()
    },
    iconAnimation () {
      const direction = this.record.data.isBot ? -100 : 100
      const icon = this.$refs.icon

      if (this.animeComponent) {
        this.anime({
          targets: icon,
          translateX: [
            { value: 0, duration: 100 },
            { value: direction, duration: 100 },
            { value: 0, duration: 500 }
          ],
          opacity: [
            { value: 0, duration: 100 },
            { value: 0, duration: 100 },
            { value: 1, duration: 250 }
          ]
        })
      } else {
        this.anime({
          targets: icon,
          translateX: 0,
          opacity: [
            { value: 0, duration: 100 },
            { value: 1, duration: 350 }
          ]
        })
      }
    },
    messageAnimation (/* messageRef */) {
      // const anime = this.anime

      // if (this.animeComponent) {
      //   const message = this.$refs[messageRef]
      //   var textWrapper = message.querySelector('.letters');
      //   textWrapper.innerHTML = textWrapper.textContent.replace(/(\S)/g, "<span class='letter'>$&</span>");

      //   anime
      //     .timeline({loop: false})
      //     .add({
      //       targets: `#${messageRef} .letter`,
      //       opacity: [0,1],
      //       easing: 'easeOutExpo',
      //       duration: 200,
      //       offset: '-=575',
      //       delay: anime.stagger(15)
      //     })
      // }
    },
    scroll() {
      this.autoScrollDesktop()
      let md = new MobileDetect(window.navigator.userAgent)
      let result = md.mobile()
      if (result === 'iPad' || result === 'iPhone') {
        this.autoScrollMobile()
      } else {
        this.autoScrollDesktop()
      }
    }
  },
  computed: {
    ...mapGetters({
      camaraName: 'app/camaraName',
      guestName: 'app/guestName'
    }),
    name () {
      return this.record.userName
    },
    alias () {
      const name = this.name || ''
      const arrNames = name.split(' ')
      const first = arrNames.shift().charAt(0)
      const last = arrNames.pop().charAt(0) || ''
      return `${first}${last}`
    },
    isMobile () {
      return this.$vuetify.breakpoint.smAndDown
    },
    timeHour () {
      // return this.record.insertedAt.toDate().toLocaleString()
      return ''
    },
    animeComponent () {
      const insertedAt = this.record.insertedAt.toDate()
      const currentDate = new Date()

      return Math.abs(currentDate - insertedAt) < 4000
    }
  },
  mounted () {
    // this.isMobile ? this.autoScrollMobile() : this.autoScrollDesktop()
    this.scroll()
  }
}
